import React, { useState } from "react";
import {
  Box,
  TextField,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  useTheme,
} from "@mui/material";
import AlertBoxComponent from "../../../Alert/AlertBoxComponent";

const PaymentInformationCard = ({
  setChooseMethod,
  setSelectedTownship,
  contact,
  setContact,
  fullName,
  setFullName,
  address,
  setAddress,
  phoneNumber,
  setPhoneNumber,
}) => {
  const theme = useTheme();
  const radioColor = theme.palette.grey.main;
  const radioCheckedColor = theme.palette.primary.main;
  const [selectedCity, setSelectedCity] = useState("yangon");
  const [open, setOpen] = useState(false);

  const handleContactChange = (event) => {
    const nextValue = event.target.value.replace(/\D/g, "");
    setContact(nextValue);
    setPhoneNumber(nextValue);
  };

  const handleNameChange = (event) => {
    const nextValue = event.target.value.replace(/[^A-Za-z\s]/g, "");
    setFullName(nextValue);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <AlertBoxComponent
        open={open}
        onClose={() => setOpen(false)}
        title={"Order Info"}
        messageParts={[
          { text: "You need to fill your information in the previous screen" },
        ]}
      />
      {/* Name */}
      <Box>
        <Typography sx={{ fontWeight: 600, marginBottom: "8px" }}>
          Name
        </Typography>
        <TextField
          fullWidth
          placeholder="Full Name"
          variant="outlined"
          size="small"
          value={fullName} // Controlled value from parent state
          onChange={handleNameChange} // Update parent state
        />
      </Box>

      {/* Phone Number */}
      <Box>
        <Typography sx={{ fontWeight: 600, marginBottom: "8px" }}>
          Phone Number
        </Typography>
        <TextField
          fullWidth
          placeholder="Phone Number"
          variant="outlined"
          size="small"
          value={contact} // Controlled value from parent state
          onChange={handleContactChange} // Update parent state
          inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
        />
      </Box>

      {/* Shipping Address */}
      <Box>
        <Typography sx={{ fontWeight: 600, marginBottom: "8px" }}>
          Shipping Address
        </Typography>

        {/* Radio Group */}
        <RadioGroup
          row
          defaultValue="yangon"
          sx={{ marginBottom: "12px" }}
          value={selectedCity}
          onChange={(e) => setSelectedCity(e.target.value)}
        >
          <FormControlLabel
            value="yangon"
            control={
              <Radio
                sx={{
                  color: radioColor,
                  "&.Mui-checked": {
                    color: radioCheckedColor,
                  },
                }}
              />
            }
            label="Yangon"
          />
          <FormControlLabel
            value="other"
            control={
              <Radio
                sx={{
                  color: radioColor,
                  "&.Mui-checked": {
                    color: radioCheckedColor,
                  },
                }}
              />
            }
            label="Other Townships"
          />
        </RadioGroup>

        {/* Address */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <TextField
            fullWidth
            placeholder="Address"
            variant="outlined"
            size="small"
            value={address} // Controlled value from parent state
            onChange={(e) => setAddress(e.target.value)} // Update parent state
          />
        </Box>
      </Box>

      {/* Navigation Buttons */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginTop: "20px",
        }}
      >
        <Button
          variant="text"
          sx={{
            textTransform: "capitalize",
            fontWeight: 600,
            color: "#000000",
          }}
          onClick={() => {
            if (!address && !phoneNumber && !fullName && !contact) {
              setOpen(true);
            } else {
              setChooseMethod(true);
              setSelectedTownship(selectedCity);
            }
          }}
        >
          Continue Payment Method &gt;
        </Button>
      </Box>
    </Box>
  );
};

export default PaymentInformationCard;
